import { useEffect } from 'react';

import { useAppDispatch } from 'redux-store/hooks';
import store from 'redux-store/store';
import { userAgentActions } from 'redux-store/userAgent/userAgent.store';
import { fontSize } from 'utils/constants/style';
import { DeviceTypeEnum, getUserAgent, OrientationTypeEnum } from 'utils/platform';

import useWindowDimensions from './useWindowDimensions';
import designTokens from '@ingka/variables/design-tokens';

const useUpdateUserAgent = () => {
  const dispatch = useAppDispatch();
  const windowDimensions = useWindowDimensions();

  useEffect(() => {
    dispatch(userAgentActions.setUserAgent(getUserAgent()));
    const { breakpointL } = designTokens;
    const state = store.getState();
    const valueWithoutEm = breakpointL.replace('em', '');
    const breakpointInPixels = Number(valueWithoutEm) * fontSize;

    const { innerWidth } = window;

    const tabletPortraitBreakpoint = innerWidth < breakpointInPixels && state.userAgent.orientation === OrientationTypeEnum.Portrait;

    const mobileAndTabletPortrait = tabletPortraitBreakpoint || state.userAgent.deviceType === DeviceTypeEnum.Mobile;

    dispatch(userAgentActions.setIsMobile(mobileAndTabletPortrait));
  }, [windowDimensions]);
};

export default useUpdateUserAgent;
